import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap';
import '../../stylings/carouselSection.css'
import BannerImage from '../../assest/banner.png';
import classroom from '../../assest/silder images/classroom.jpg'
import computerlab from '../../assest/silder images/computer lab.jpg'
import cooking from '../../assest/silder images/cooking.jpg'
import campaign from '../../assest/silder images/campaign.jpg'
import independenceday from '../../assest/silder images/independence day.jpg'
import picnic from '../../assest/silder images/picnic.jpg'
import summercamp from '../../assest/silder images/summer campaign.jpg'
import taekwondo from '../../assest/silder images/taekwondo.jpg'
import earthday from '../../assest/silder images/earthday.jpg'
import wastematerial from '../../assest/silder images/wastematerial.jpg'

const CarouselSection = () => {
  // Sample data for carousel items
  const carouselItems = [
    {
      id: 1,
      // title: 'Slide 1',
      content: 'Front View of Way, Truth and Life Foundation School',
      image: BannerImage,
    },
    {
      id: 2,
      // title: 'Slide 2',
      content: 'Student Studying in Classroom',
      image: classroom,
    },
    {
      id: 3,
      // title: 'Slide 3',
      content: 'Computer Lab Room',
      image: computerlab,
    },
    {
      id: 4,
      // title: 'Slide 1',
      content: 'Student Celebrating Independence Day',
      image: independenceday,
    },
    {
      id: 5,
      // title: 'Slide 2',
      content: 'Student Picnic organized by School',
      image: picnic,
    },
    {
      id: 6,
      // title: 'Slide 3',
      content: 'Summer Camp organized.',
      image: summercamp,
    },
    {
      id: 7,
      // title: 'Slide 3',
      content: 'Students Envolved in Cooking',
      image: cooking,
    },
    {
      id: 8,
      // title: 'Slide 3',
      content: 'Camp Organized by Way, Truth and Life Foundation School.',
      image: campaign,
    },
    {
      id: 9,
      // title: 'Slide 3',
      content: 'Taekwondo Session',
      image: taekwondo,
    },
    {
      id: 10,
      // title: 'Slide 3',
      content: 'Earth Day Celebration',
      image: earthday,
    },
    {
      id: 11,
      // title: 'Slide 3',
      content: 'Waste Material Event',
      image: wastematerial,
    }
  ];

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="carousel-container">
      <Carousel activeIndex={index} onSelect={handleSelect}>
        {carouselItems.map((item) => (
          <Carousel.Item key={item.id}>
            <img
              className="d-block w-100"
              src={item.image}
              alt={`Slide ${item.id}`}
            />
            <Carousel.Caption>
              <p>{item.content}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselSection
